import { createAction } from '@ngrx/store';

export const show = createAction('NAV_SHOW');
export const hide = createAction('NAV_HIDE');
